export function escapeChipKey(k) {
  return String(k)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function chipHTML(key) {
  const k = escapeChipKey(key.trim());
  return `<span class="param-chip" contenteditable="false" data-key="${k}">@${k}<span class="param-chip-remove" role="button" tabindex="-1" aria-label="Remove">×</span></span>`;
}

export function textToHTML(text) {
  if (!text) return '';
  const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return escaped.replace(/\{\{([^}]+)\}\}/g, (_, key) => chipHTML(key));
}

export function htmlToPlainText(el) {
  const clone = el.cloneNode(true);
  clone.querySelectorAll('.param-chip').forEach(chip => {
    const key = chip.getAttribute('data-key');
    chip.replaceWith(`{{${key}}}`);
  });
  clone.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
  let text = clone.textContent || '';
  text = text
    .replace(/\u200b|\u200c|\u200d|\u2060/g, '')
    .replace(/\ufeff/g, '')
    .replace(/\u00a0/g, ' ');
  return /^\s*$/u.test(text) ? '' : text;
}

export function mustachePlaceholdersToParamChipHtml(html) {
  if (!html) return '';
  return html.replace(/\{\{([^}]+)\}\}/g, (_, rawKey) => chipHTML(rawKey));
}

export function paramChipHtmlToMustachePlaceholders(html) {
  if (!html) return '';
  // Avoid DOM round-trip when there are no chips — innerHTML would encode & as &amp;
  // and break callers that render the result as plain text (e.g. section titles).
  if (!html.includes('param-chip')) return html;
  try {
    const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
    const root = doc.body.firstElementChild;
    if (!root) return html;
    root.querySelectorAll('.param-chip').forEach(chip => {
      const key = chip.getAttribute('data-key') || chip.getAttribute('data-param');
      if (key != null && key !== '') {
        chip.replaceWith(doc.createTextNode(`{{${key}}}`));
      }
    });
    return root.innerHTML;
  } catch {
    return html;
  }
}

export function normalizeRichTextParamStorage(html, asMustache) {
  if (!asMustache) return html || '';
  return paramChipHtmlToMustachePlaceholders(mustachePlaceholdersToParamChipHtml(html || ''));
}
